module.exports = __webpack_public_path__ + "img/calendar2-plus.ae5ef715.svg";